import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import ShieldCheck from "../../../../assets/shield_check.svg?react";
import ShieldTwoToneIcon from "@mui/icons-material/ShieldTwoTone";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import HourGlassIcon from "../../../../assets/hourglass-half.svg?react";
import { Alert as MAlert, Fade, Stack, Typography } from "@mui/material";
import classNames from "classnames/bind";
import styles from "./Alert.module.scss";
import { textToMarkdown } from "../../../utils/react-utils";

let cx = classNames.bind(styles);

interface IBAlertProperties {
    variant: "error" | "info" | "success" | "warning";
    title?: string;
    children?: any;
    icon?: string;
    sx?: object;
    className?: string;
    width?: string;
}

const IconMap = {
    ShieldTwoToneIcon: ShieldTwoToneIcon,
    ShieldCheck: ShieldCheck,
    AccessTimeIcon: AccessTimeIcon,
    success: CheckCircleIcon,
    warning: ErrorIcon,
    error: WarningRoundedIcon,
    info: InfoIcon,
    HourGlassIcon: HourGlassIcon,
};

const getIcon = (iconName, variant) => {
    const Icon = IconMap[iconName] || IconMap[variant];
    if (Icon) {
        return <Icon className={cx("Icon")} />;
    }
    return null;
};

const Alert = (props: IBAlertProperties) => {
    const {
        variant = "info",
        title,
        icon = "",
        sx,
        className = "",
        children,
        width = "fit-content",
    } = props;

    return (
        <Stack sx={{ width }}>
            <Fade in={true}>
                <MAlert
                    className={cx("Alert", variant, className)}
                    variant="outlined"
                    icon={getIcon(icon, variant)}
                    sx={{ ...sx }}
                    data-testid={`alert-msg-${variant}`}
                >
                    <Typography
                        variant="typography11"
                        className={cx("Content")}
                    >
                        {title ? textToMarkdown(title) : children}
                    </Typography>
                </MAlert>
            </Fade>
        </Stack>
    );
};

export default Alert;
